import {
  Box,
  Checkbox,
  Grid,
  Slider,
  Typography,
  TextField,
  MenuItem,
  Autocomplete,
  CircularProgress,
} from "@mui/material";
import styles from "../InternalTracker.module.css";
import { customTextColor } from "../../../utils/const";
import MoreFilterPublicResume from "../../../components/containers/MoreFilterPublicResume";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { allSkill } from "../../../redux/common/skillSlice";
import {
  getAllRecruiterCandidateNextPrevious,
  getTrackerDetails,
} from "../../../redux/internal-tracking/InternalTrackerSlice";
import {
  fieldStyle,
  prefer_tax_term1,
  work_preference1,
} from "../../../utils/const2";

import { FixedSizeList } from "react-window";
import React from "react";
import VirtualizedAutocomplete from "./VirtualizedAutocomplete";
import { allWorkAuthorization } from "../../../redux/common/workAuthorizationSlice";
import { allLocation } from "../../../redux/common/locationSlice";
import InternalCandidateViewdrawer from "./InternalCandidateViewDrawer";
import SearchSelectJobDrawer from "../../PostSearch/SearchSelectJobDrawer";
import CandidateViewDrawer from "../../../screens2/Candidates/CandidateListing/CandidateViewDrawer";
import SendRequirementDrawer from "./SendRequirementDrawer";

const renderVirtualizedList = (props) => {
  const { children, ...rest } = props;

  return (
    <FixedSizeList
      height={300} // Height of the dropdown
      width="100%" // Full width of dropdown
      itemSize={46} // Height of each item
      itemCount={children.length} // Number of items
      outerElementType={props.Component} // Ensure correct list wrapper
    >
      {({ index, style }) => React.cloneElement(children[index], { style })}
    </FixedSizeList>
  );
};

const JobSearchResult = () => {
  const [typeResult, setTypeResult] = useState("public");
  const [hotListRow, setHotListRow] = useState([]);
  const [type, setType] = useState("");
  const [publicMatching, setPublicMatching] = useState([]);
  const [privateMatching, setPrivateMatching] = useState([]);
  const [communitMatching, setCommunitMatching] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [expandedDiagnosis, setExpandedDiagnosis] = useState(false);
  const [showView, setShowView] = useState(false);
  const handleCloseView = () => setShowView(false);
  const handleViewShow = () => setShowView(true);
  const [show, setShow] = useState(false);
  const handleCloseShow = () => setShow(false);
  const handleShow = () => setShow(true);
  const [showSelected, setShowSelected] = useState(false);
  const handleCloseShowSelected = () => setShowSelected(false);
  const handleShowSelected = () => setShowSelected(true);
  const [showCandidate, setShowCandidate] = useState(false);
  const handleCloseShowCandidate = () => setShowCandidate(false);
  const handleShowCandidate = () => setShowCandidate(true);
  const [submisionRow, setSubmisionRow] = useState({});
  const [isFilterd, setIsFiltered] = useState(false);
  const [searchData, setSearchData] = useState({
    prefer_tax_term: [],
    work_authorization: [],
    work_preference: [],
    skill: [],
    location: [],
    rate: "",
    domain_name: "",
    updated_at: "",
    // filter_for: "both", // Static value
  });

  const label = { inputProps: { "aria-label": "Checkbox demo" } };

  const location = useLocation();
  const dispatch = useDispatch();
  // const { trackDetails } = location?.state || {};
  const trackDetails = useSelector((state) => state.tracker);
  const trackerLoading = useSelector((state) => state.tracker.status);

  const workautho = useSelector((state) => state.workautho);
  const locations = useSelector((state) => state.location);
  const skillData = useSelector((state) => state.skill.data);

  useEffect(() => {
    if (typeResult === "public") {
      setPrivateMatching(trackDetails?.data?.results?.data);
    }
    if (typeResult === "internal") {
      setPublicMatching(trackDetails?.data?.results?.data);
    }
    if (typeResult === "comunity") {
      setCommunitMatching(trackDetails?.data?.results?.data);
    }
  }, [trackDetails, typeResult]);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleChangeDiagnosis = (panel) => (event, isExpanded) => {
    setExpandedDiagnosis(isExpanded ? panel : false);
  };
  const navigate = useNavigate();
  const [skills, setSkills] = useState([{}]);

  // const handleAddSkill = () => {
  //   setSkills([...skills, { skill: '', experience: '' }]);
  // };

  const getPreferLocationNames = (preferLocation) => {
    return preferLocation
      ?.map(
        (id) =>
          locations?.data?.locations?.find((location) => location.id === id)
            ?.name
      ) // Map IDs to names
      ?.filter(Boolean) // Remove any undefined values if IDs don't match
      ?.join(", "); // Join names with a comma and space
  };

  const getLocationById = (id) => {
    let locationResult = locations?.data?.locations?.find(
      (res) => res.id === id
    );
    return locationResult?.name;
  };

  const getWorkAuthorization = (id) => {
    let authorizationResult = workautho?.data?.work_authorization_data?.find(
      (res) => res.id === id
    );
    return authorizationResult?.name;
  };
  //   const matchingSkills = (row) => {
  //     let allSkills = skillData?.locations?.filter((skill) => {
  //       row?.includes(skill.id);
  //     });

  //     return allSkills;
  //   };

  const matchingSkills = (row) => {
    // Filter skills based on matching IDs in the row
    const allSkills = skillData?.locations?.filter((skill) =>
      row?.includes(skill.id)
    );

    // Extract only the names of the matching skills
    const skillNames = allSkills?.map((skill) => skill.name);

    const displayedSkills =
      skillNames?.length > 2
        ? `${skillNames.slice(0, 2).join(", ")}...`
        : skillNames?.join(", ");

    return displayedSkills;

    // return skillNames?.join(", ");
  };

  const matchingSkills2nd = (row) => {
    // Filter skills based on matching IDs in the row
    const allSkills = skillData?.locations?.filter((skill) =>
      row?.includes(skill.id)
    );

    // Extract only the names of the matching skills
    const skillNames = allSkills?.map((skill) => skill.name);

    return skillNames?.join(", ");
  };

  useEffect(() => {
    dispatch(allWorkAuthorization());
    dispatch(allLocation());
    dispatch(allSkill());
  }, []);

  const handleModeOfHiringCheckboxChange = (category, option) => {
    setSearchData((prev) => ({
      ...prev,
      [category]: prev[category].includes(option)
        ? prev[category].filter((item) => item !== option)
        : [...prev[category], option],
    }));
  };

  const handleTextFieldChange = (category, value) => {
    setSearchData((prev) => ({
      ...prev,
      [category]: value,
    }));
  };

  // useEffect(() => {
  //   if (searchData) {
  //     const queryParams = Object.keys(searchData).reduce((acc, key) => {
  //       const value = searchData[key];

  //       if (Array.isArray(value) && value.length > 0) {
  //         // Send arrays as JSON strings
  //         acc[key] = JSON.stringify(value);
  //       } else if (
  //         value !== "" &&
  //         value !== null &&
  //         value !== undefined &&
  //         !Array.isArray(value)
  //       ) {
  //         // Include non-empty strings or numbers
  //         acc[key] = value;
  //       }
  //       return acc;
  //     }, {});

  //     // Convert queryParams into a query string
  //     const queryString = Object.entries(queryParams)
  //       .map(
  //         ([key, value]) =>
  //           `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
  //       )
  //       .join("&");

  //     // Dispatch the action with the query string
  //     dispatch(getTrackerDetails(queryString));
  //   } else {
  //     dispatch(getTrackerDetails(""));
  //   }
  // }, [searchData, dispatch]);

  useEffect(() => {
    if (searchData) {
      const queryParams = Object.keys(searchData).reduce((acc, key) => {
        const value = searchData[key];

        if (Array.isArray(value) && value.length > 0) {
          // Send arrays as JSON strings
          acc[key] = JSON.stringify(value);
        } else if (
          value !== "" &&
          value !== null &&
          value !== undefined &&
          !Array.isArray(value)
        ) {
          // Include non-empty strings or numbers
          acc[key] = value;
        }
        return acc;
      }, {});

      // Add filter based on typeResult
      if (typeResult === "internal") {
        queryParams["filter_for"] = "other_public_candidates";
      } else if (typeResult === "comunity") {
        queryParams["filter_for"] = "community_candidates";
      }

      // Convert queryParams into a query string
      const queryString = Object.entries(queryParams)
        .map(
          ([key, value]) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        )
        .join("&");

      // Dispatch the action with the query string
      dispatch(getTrackerDetails(queryString));
    } else {
      if (typeResult === "internal") {
        let queryParams = "filter_for=other_public_candidates";
        dispatch(getTrackerDetails(queryParams));
      } else if (typeResult === "comunity") {
        let queryParams = "filter_for=community_candidates";
        dispatch(getTrackerDetails(queryParams));
      } else {
        let queryString = `page=1&page_size=10`;
        dispatch(getTrackerDetails(queryString));
      }
    }
  }, [searchData, typeResult, dispatch]);

  const handleOnClickNextPrevious = (type) => {
    if (typeResult === "public") {
      if (type === "next") {
        let url = trackDetails?.data?.next;
        dispatch(getAllRecruiterCandidateNextPrevious(url));
      } else {
        let url = trackDetails?.data?.previous;
        dispatch(getAllRecruiterCandidateNextPrevious(url));
      }
    } else if (typeResult === "internal") {
      if (type === "next") {
        let url = trackDetails?.data?.next;
        dispatch(getAllRecruiterCandidateNextPrevious(url));
      } else {
        let url = trackDetails?.data?.previous;
        dispatch(getAllRecruiterCandidateNextPrevious(url));
      }
    } else if (typeResult === "comunity") {
      if (type === "next") {
        let url = trackDetails?.data?.next;
        dispatch(getAllRecruiterCandidateNextPrevious(url));
      } else {
        let url = trackDetails?.data?.previous;
        dispatch(getAllRecruiterCandidateNextPrevious(url));
      }
    }
  };

  const IsDisableNext = () => {
    let result = false;
    if (typeResult === "public") {
      if (trackDetails?.data?.next === null) {
        result = true;
      } else {
        result = false;
      }
    }
    if (typeResult === "internal") {
      if (trackDetails?.data?.next === null) {
        result = true;
      } else {
        result = false;
      }
    }
    if (typeResult === "comunity") {
      if (trackDetails?.data?.next === null) {
        result = true;
      } else {
        result = false;
      }
    }
    return result;
  };

  const IsDisablePrevious = () => {
    let result = false;
    if (typeResult === "public") {
      if (trackDetails?.data?.previous === null) {
        result = true;
      } else {
        result = false;
      }
    }
    if (typeResult === "internal") {
      if (trackDetails?.data?.previous === null) {
        result = true;
      } else {
        result = false;
      }
    }
    if (typeResult === "comunity") {
      if (trackDetails?.data?.previous === null) {
        result = true;
      } else {
        result = false;
      }
    }
    return result;
  };

  const hassearchDataValue = Object.values(searchData).some((value) => {
    if (Array.isArray(value)) {
      return value.length > 0; // Check if array is not empty
    }
    return value !== "" && value !== null && value !== undefined; // Check for non-empty strings and non-null values
  });

  useEffect(() => {
    if (hassearchDataValue) {
      setIsFiltered(true);
    }
  }, [hassearchDataValue]);

  const toggleSelect = (id) => {
    const updateCandidate = privateMatching?.map((candidate) =>
      candidate?.id === id
        ? { ...candidate, selected: !candidate.selected }
        : candidate
    );
    setPrivateMatching(updateCandidate);
  };

  let selectedCandidate = privateMatching?.filter(
    (res) => res?.selected === true
  );

  useEffect(() => {
    if (selectedCandidate?.length > 0) {
      handleShowSelected();
    } else {
      handleCloseShowSelected();
    }
  }, [selectedCandidate]);

  return (
    // <RootComponents>
    <Box className={styles}>
      <Grid container>
        <Grid item xs={12} sm={12} md={2.5} lg={2.5}>
          <Accordion
            className="accordion_body"
            expanded={expanded === "subpanel3"}
            onChange={handleChange("subpanel3")}
            style={{ border: "1px solid #f2f2f2", margin: "14px " }}
          >
            <AccordionSummary
              expandIcon={
                expanded === "subpanel3" ? <RemoveIcon /> : <AddIcon />
              }
              aria-controls="panel1-content"
              className={styles.accordion_text}
            >
              Mode of Hiring
            </AccordionSummary>
            <AccordionDetails>
              <Box>
                {prefer_tax_term1.map((option, index) => (
                  <Box
                    key={index}
                    sx={{
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>{option?.label}</span>
                    <Checkbox
                      checked={searchData.prefer_tax_term.includes(
                        option?.value
                      )}
                      onChange={() =>
                        handleModeOfHiringCheckboxChange(
                          "prefer_tax_term",
                          option?.value
                        )
                      }
                      sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
                    />
                  </Box>
                ))}
              </Box>
            </AccordionDetails>
          </Accordion>
          <Accordion
            className="accordion_body"
            expanded={expanded === "subpanel1"}
            onChange={handleChange("subpanel1")}
            style={{ border: "1px solid #f2f2f2", margin: "14px" }}
          >
            <AccordionSummary
              expandIcon={
                expanded === "subpanel1" ? <RemoveIcon /> : <AddIcon />
              }
              aria-controls="panel1-content"
              id="panel1-header"
              className={styles.accordion_text}
            >
              Location
            </AccordionSummary>
            <AccordionDetails sx={{ padding: "0px" }}>
              <Autocomplete
                multiple
                id="autocomplete-multi-select"
                options={locations?.data?.locations || []}
                disableCloseOnSelect
                value={
                  locations?.data?.locations?.filter((skl) =>
                    searchData.location?.includes(skl.id)
                  ) || []
                }
                onChange={(event, value) => {
                  // Update the `searchData` state when skills are selected
                  const selectedLocationId = value?.map((skl) => skl?.id);
                  setSearchData((prev) => ({
                    ...prev,
                    location: selectedLocationId, // Update the skills array in searchData
                  }));
                }}
                getOptionLabel={(option) => option?.name || ""}
                renderOption={(props, option, { selected }) => (
                  <MenuItem {...props}>
                    <Checkbox
                      checked={selected}
                      sx={{ marginRight: 0, marginLeft: 0 }}
                    />
                    <span>{option?.name}</span>
                  </MenuItem>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Location"
                    variant="standard"
                    size="small"
                    name="skills"
                    sx={fieldStyle}
                  />
                )}
                sx={{
                  backgroundColor: "#fff",
                  width: "100%",
                  paddingBottom: "10px",
                }}
              />
            </AccordionDetails>
          </Accordion>
          <Accordion
            className="accordion_body"
            expanded={expanded === "subpanel2"}
            onChange={handleChange("subpanel2")}
            style={{ border: "1px solid #f2f2f2", margin: "14px" }}
          >
            <AccordionSummary
              expandIcon={
                expanded === "subpanel2" ? <RemoveIcon /> : <AddIcon />
              }
              aria-controls="panel1-content"
              className={styles.accordion_text}
            >
              Visa
            </AccordionSummary>
            <AccordionDetails
              sx={{
                height: "10rem",
                overflowY: "scroll",
                padding: "8px 7px 16px",
              }}
            >
              <Autocomplete
                multiple
                id="autocomplete-multi-select"
                options={workautho?.data?.work_authorization_data || []}
                disableCloseOnSelect
                value={
                  workautho?.data?.work_authorization_data?.filter((skl) =>
                    searchData.work_authorization?.includes(skl.id)
                  ) || []
                }
                onChange={(event, value) => {
                  // Update the `searchData` state when skills are selected
                  const selectedSkillIds = value?.map((skl) => skl?.id);
                  setSearchData((prev) => ({
                    ...prev,
                    work_authorization: selectedSkillIds, // Update the skills array in searchData
                  }));
                }}
                getOptionLabel={(option) => option?.name || ""}
                renderOption={(props, option, { selected }) => (
                  <MenuItem {...props}>
                    <Checkbox
                      checked={selected}
                      sx={{ marginRight: 0, marginLeft: 0 }}
                    />
                    <span>{option?.name}</span>
                  </MenuItem>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Visa"
                    variant="standard"
                    size="small"
                    name="skills"
                    sx={fieldStyle}
                  />
                )}
                sx={{ backgroundColor: "#fff", width: "100%" }}
              />
            </AccordionDetails>
          </Accordion>
          <Accordion
            className="accordion_body"
            expanded={expanded === "subpanel4"}
            onChange={handleChange("subpanel4")}
            style={{ border: "1px solid #f2f2f2", margin: "14px" }}
          >
            <AccordionSummary
              expandIcon={
                expanded === "subpanel4" ? <RemoveIcon /> : <AddIcon />
              }
              aria-controls="panel1-content"
              className={styles.accordion_text}
            >
              Work Preference
            </AccordionSummary>
            <AccordionDetails>
              <Box>
                {work_preference1.map((option, index) => (
                  <Box
                    key={index}
                    sx={{
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>{option?.label}</span>
                    <Checkbox
                      checked={searchData.work_preference.includes(
                        option?.value
                      )}
                      onChange={() =>
                        handleModeOfHiringCheckboxChange(
                          "work_preference",
                          option?.value
                        )
                      }
                      sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
                    />
                  </Box>
                ))}
              </Box>
            </AccordionDetails>
          </Accordion>
          {/* <Accordion
              className="accordion_body"
              expanded={expanded === "subpanel7"}
              onChange={handleChange("subpanel7")}
              style={{ border: "1px solid #f2f2f2", margin: "14px" }}
            >
              <AccordionSummary
                expandIcon={
                  expanded === "subpanel7" ? <RemoveIcon /> : <AddIcon />
                }
                aria-controls="panel1-content"
                // id="panel1-header"
                className={styles.accordion_text}
              >
                Candidate Status
              </AccordionSummary>
              <AccordionDetails>
                <Box>
                  <Box
                    sx={{
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>Verified Candidate</span>
                    <Checkbox
                      {...label}
                      sx={{ "& .MuiSvgIcon-root": { fontSize: 24 } }}
                    />
                  </Box>
                  <Box
                    sx={{
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>Verified Recruiter</span>
                    <Checkbox
                      {...label}
                      sx={{ "& .MuiSvgIcon-root": { fontSize: 24 } }}
                    />
                  </Box>
                </Box>
              </AccordionDetails>
            </Accordion> */}
          {/* <Accordion
              className="accordion_body"
              expanded={expanded === "subpanel8"}
              onChange={handleChange("subpanel8")}
              style={{ border: "1px solid #f2f2f2", margin: "14px" }}
            >
              <AccordionSummary
                expandIcon={
                  expanded === "subpanel8" ? <RemoveIcon /> : <AddIcon />
                }
                aria-controls="panel1-content"
                className={styles.accordion_text}
              >
                Search by skills
              </AccordionSummary>
              <AccordionDetails>
                <Autocomplete
                  multiple
                  id="autocomplete-multi-select"
                  options={skillData?.locations || []}
                  disableCloseOnSelect
                  value={
                    skillData?.locations?.filter((skl) =>
                      formik.values.skills?.includes(skl.id)
                    ) || []
                  }
                  onChange={(event, value) => {
                    const selectedLocations = value?.map((skl) => skl?.id);
                    formik.setFieldValue("skills", selectedLocations);
                  }}
                  onBlur={formik.handleBlur}
                  getOptionLabel={(option) => option?.name || ""}
                  renderOption={(props, option, { selected }) => (
                    <MenuItem {...props}>
                      <Checkbox
                        checked={selected}
                        sx={{ marginRight: 0, marginLeft: 0 }}
                      />
                      <span>{option?.name}</span>{" "}
                    </MenuItem>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Skills"
                      variant="standard"
                      size="small"
                      name="skills"
                      sx={fieldStyle}
                    />
                  )}
                  sx={{ backgroundColor: "#fff", width: "100%" }}
                />
              
              </AccordionDetails>
            </Accordion> */}
          {/* <Accordion
              className="accordion_body"
              expanded={expanded === "subpanel8"}
              onChange={handleChange("subpanel8")}
              style={{ border: "1px solid #f2f2f2", margin: "14px" }}
            >
              <AccordionSummary
                expandIcon={
                  expanded === "subpanel8" ? <RemoveIcon /> : <AddIcon />
                }
                aria-controls="panel1-content"
                className={styles.accordion_text}
              >
                Skills
              </AccordionSummary>
              <AccordionDetails>
                <Autocomplete
                  multiple
                  id="autocomplete-multi-select"
                  options={skillData?.locations || []}
                  disableCloseOnSelect
                  value={
                    skillData?.locations?.filter((skl) =>
                      searchData.skill?.includes(skl.id)
                    ) || []
                  }
                  onChange={(event, value) => {
                    // Update the `searchData` state when skills are selected
                    const selectedSkillIds = value?.map((skl) => skl?.id);
                    setSearchData((prev) => ({
                      ...prev,
                      skill: selectedSkillIds, // Update the skills array in searchData
                    }));
                  }}
                  getOptionLabel={(option) => option?.name || ""}
                  renderOption={(props, option, { selected }) => (
                    <MenuItem {...props}>
                      <Checkbox
                        checked={selected}
                        sx={{ marginRight: 0, marginLeft: 0 }}
                      />
                      <span>{option?.name}</span>
                    </MenuItem>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Skills"
                      variant="standard"
                      size="small"
                      name="skills"
                      sx={fieldStyle}
                    />
                  )}
                  sx={{ backgroundColor: "#fff", width: "100%" }}
                />
              </AccordionDetails>
            </Accordion> */}

          {/* <Accordion
              className="accordion_body"
              expanded={expanded === "subpanel8"}
              onChange={handleChange("subpanel8")}
              style={{ border: "1px solid #f2f2f2", margin: "14px" }}
            >
              <AccordionSummary
                expandIcon={
                  expanded === "subpanel8" ? <RemoveIcon /> : <AddIcon />
                }
                aria-controls="panel1-content"
                className={styles.accordion_text}
              >
                Skills
              </AccordionSummary>
              <AccordionDetails>
                <Autocomplete
                  multiple
                  id="autocomplete-multi-select"
                  options={skillData?.locations || []} // Full dataset
                  disableCloseOnSelect
                  value={
                    skillData?.locations?.filter((skl) =>
                      searchData.skill?.includes(skl.id)
                    ) || []
                  }
                  onChange={(event, value) => {
                    const selectedSkillIds = value?.map((skl) => skl?.id);
                    setSearchData((prev) => ({
                      ...prev,
                      skill: selectedSkillIds,
                    }));
                  }}
                  getOptionLabel={(option) => option?.name || ""} // Display skill name
                  renderOption={(props, option, { selected }) => (
                    <MenuItem {...props}>
                      <Checkbox
                        checked={selected}
                        sx={{ marginRight: 0, marginLeft: 0 }}
                      />
                      <span>{option?.name}</span>
                    </MenuItem>
                  )}
                  ListboxComponent={renderVirtualizedList} // Virtualize the dropdown
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Skills"
                      variant="standard"
                      size="small"
                      name="skills"
                      sx={fieldStyle}
                    />
                  )}
                  sx={{ backgroundColor: "#fff", width: "100%" }}
                />
              </AccordionDetails>
            </Accordion> */}
          <Accordion
            className="accordion_body"
            expanded={expanded === "subpanel8"}
            onChange={handleChange("subpanel8")}
            style={{ border: "1px solid #f2f2f2", margin: "14px" }}
          >
            <AccordionSummary
              expandIcon={
                expanded === "subpanel8" ? <RemoveIcon /> : <AddIcon />
              }
              aria-controls="panel1-content"
              className={styles.accordion_text}
            >
              Skills
            </AccordionSummary>
            <AccordionDetails>
              <VirtualizedAutocomplete
                skillData={skillData}
                searchData={searchData}
                setSearchData={setSearchData}
                fieldStyle={fieldStyle}
              />
            </AccordionDetails>
          </Accordion>
          {/* <Accordion
              className="accordion_body"
              expanded={expanded === "subpanel9"}
              onChange={handleChange("subpanel9")}
              style={{ border: "1px solid #f2f2f2", margin: "14px" }}
            >
              <AccordionSummary
                expandIcon={
                  expanded === "subpanel9" ? <RemoveIcon /> : <AddIcon />
                }
                aria-controls="panel1-content"
                className={styles.accordion_text}
              >
                Search by Domain
              </AccordionSummary>
              <AccordionDetails>
                {skills.map((skill, index) => (
                  <Grid container key={index} spacing={2} alignItems="center">
                    <Grid item xs={12} sm={12} md={11} lg={11}>
                      <TextField
                        variant="outlined"
                        sx={{
                          width: "100%",
                          padding: "5px !important",
                          "& .MuiInputBase-input": {
                            padding: "10px", // Add padding to the input text itself to make space for the icon
                          },
                        }}
                        value={skill}
                        onChange={(e) => {
                          const newSkills = [...skills];
                          newSkills[index] = e.target.value;
                          setSkills(newSkills);
                        }}
                      />
                    </Grid>

                    {skills.length === index + 1 && (
                      <Grid
                        item
                        xs={12}
                        md={0.6}
                        sx={{ padding: "0 !important", marginTop: "15px" }}
                      >
                        <AddIcon
                          onClick={handleAddSkill}
                          style={{ cursor: "pointer" }}
                        />
                      </Grid>
                    )}

                    {(skills.length < 1 || skills.length !== index + 1) && (
                      <Grid
                        item
                        xs={12}
                        md={0.6}
                        sx={{ padding: "0 !important", marginTop: "15px" }}
                      >
                        <RemoveIcon
                          onClick={() => handleRemoveSkill(index)}
                          style={{ cursor: "pointer" }}
                        />
                      </Grid>
                    )}
                  </Grid>
                ))}
              </AccordionDetails>
            </Accordion> */}
          {/* <Accordion
            className="accordion_body"
            expanded={expanded === "subpanel9"}
            onChange={handleChange("subpanel9")}
            style={{ border: "1px solid #f2f2f2", margin: "14px" }}
          >
            <AccordionSummary
              expandIcon={
                expanded === "subpanel9" ? <RemoveIcon /> : <AddIcon />
              }
              aria-controls="panel5-content"
              className={styles.accordion_text}
            >
              Search by Domain
            </AccordionSummary>
            <AccordionDetails>
              <Box>
                <TextField
                  type="text"
                  label="Enter Domain"
                  variant="outlined"
                  size="small"
                  value={searchData.domain_name || ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    setSearchData((prev) => ({
                      ...prev,
                      domain_name: value, // Update the rate in searchData
                    }));
                  }}
                  sx={{ width: "100%" }}
                />
              </Box>
            </AccordionDetails>
          </Accordion> */}
          {/* <Accordion
              className="accordion_body"
              expanded={expanded === "subpanel5"}
              onChange={handleChange("subpanel5")}
              style={{ border: "1px solid #f2f2f2", margin: "14px" }}
            >
              <AccordionSummary
                expandIcon={
                  expanded === "subpanel5" ? <RemoveIcon /> : <AddIcon />
                }
                aria-controls="panel1-content"
                // id="panel1-header"
                className={styles.accordion_text}
              >
                Search by Rate
              </AccordionSummary>
              <AccordionDetails>
                <Box>
                  <Box
                    sx={{
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>Hourly Rate</span>
                    <Checkbox
                      {...label}
                      sx={{ "& .MuiSvgIcon-root": { fontSize: 24 } }}
                    />
                  </Box>
                  <Box
                    sx={{
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>Salaried</span>
                    <Checkbox
                      {...label}
                      sx={{ "& .MuiSvgIcon-root": { fontSize: 24 } }}
                    />
                  </Box>
                </Box>
              </AccordionDetails>
            </Accordion> */}
          <Accordion
            className="accordion_body"
            expanded={expanded === "subpanel5"}
            onChange={handleChange("subpanel5")}
            style={{ border: "1px solid #f2f2f2", margin: "14px" }}
          >
            <AccordionSummary
              expandIcon={
                expanded === "subpanel5" ? <RemoveIcon /> : <AddIcon />
              }
              aria-controls="panel5-content"
              className={styles.accordion_text}
            >
              Search by Rate
            </AccordionSummary>
            <AccordionDetails>
              <Box>
                <TextField
                  type="number"
                  label="Enter Rate"
                  variant="outlined"
                  size="small"
                  value={searchData.rate || ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    setSearchData((prev) => ({
                      ...prev,
                      rate: value, // Update the rate in searchData
                    }));
                  }}
                  sx={{ width: "100%" }}
                />
              </Box>
            </AccordionDetails>
          </Accordion>
          {/* <Accordion
              className="accordion_body"
              expanded={expanded === "subpanel6"}
              onChange={handleChange("subpanel6")}
              style={{ border: "1px solid #f2f2f2", margin: "14px" }}
            >
              <AccordionSummary
                expandIcon={
                  expanded === "subpanel6" ? <RemoveIcon /> : <AddIcon />
                }
                aria-controls="panel1-content"
                // id="panel1-header"
                className={styles.accordion_text}
              >
                Resume Updated In
              </AccordionSummary>
              <AccordionDetails>
                <Box
                  sx={{
                    alignItems: "center",
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "column",
                    marginTop: "20px",
                  }}
                >
                  <span>Days</span>
                  <Slider
                    defaultValue={0}
                    aria-label="Default"
                    valueLabelDisplay="on"
                  />
                </Box>
              </AccordionDetails>
            </Accordion> */}
          <Accordion
            className="accordion_body"
            expanded={expanded === "subpanel6"}
            onChange={handleChange("subpanel6")}
            style={{ border: "1px solid #f2f2f2", margin: "14px" }}
          >
            <AccordionSummary
              expandIcon={
                expanded === "subpanel6" ? <RemoveIcon /> : <AddIcon />
              }
              aria-controls="panel6-content"
              className={styles.accordion_text}
            >
              Resume Updated In
            </AccordionSummary>
            <AccordionDetails>
              <Box
                sx={{
                  alignItems: "center",
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "column",
                  marginTop: "20px",
                }}
              >
                <span>Days</span>
                <Slider
                  value={searchData.updated_at || 0}
                  onChange={(e, newValue) => {
                    setSearchData((prev) => ({
                      ...prev,
                      updated_at: newValue, // Update resume_updated_in in searchData
                    }));
                  }}
                  min={0}
                  max={180} // Adjust the range as needed
                  step={1}
                  aria-label="Resume Updated In"
                  valueLabelDisplay="on"
                  sx={{ width: "100%" }}
                />
              </Box>
            </AccordionDetails>
          </Accordion>
        </Grid>

        <Grid item xs={12} sm={12} md={9.5} lg={9.5}>
          <Grid container>
            {/* <Grid item xs={12} sm={12} md={12} lg={12}>
                                <Box className={styles.job_serach_result_heading}>
                                    <Typography sx={{ color: customTextColor }}>SEARCH RESULT</Typography>
                                </Box>
                            </Grid> */}
            {/* <Grid item xs={12} sm={12} md={7} lg={7} sx={{ padding: '10px 10px 10px 0' }}>
                                <TextField
                                    label="JOB INFORMATION"
                                    variant="outlined"
                                    sx={{ width: "100%" }}
                                />
                            </Grid> */}
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              sx={{ padding: "15px 14px 0 0" }}
            >
              <Box className={styles.choose_resume}>
                <Typography
                  onClick={() => setTypeResult("public")}
                  sx={
                    typeResult === "public"
                      ? { color: "#1991e0" }
                      : { color: customTextColor }
                  }
                >
                  Private {isFilterd ? "Matching" : "Profile"}{" "}
                  {trackDetails?.data?.results?.counts?.my_candidate_count}
                </Typography>
                <Typography
                  onClick={() => setTypeResult("internal")}
                  sx={
                    typeResult === "internal"
                      ? { color: "#1991e0" }
                      : { color: customTextColor }
                  }
                >
                  Internal {isFilterd ? "Matching" : "Profile"}{" "}
                  {
                    trackDetails?.data?.results?.counts
                      ?.other_public_candidates_count
                  }
                </Typography>
                <Typography
                  onClick={() => setTypeResult("comunity")}
                  sx={
                    typeResult === "comunity"
                      ? { color: "#1991e0" }
                      : { color: customTextColor }
                  }
                >
                  Community {isFilterd ? "Matching" : "Profile"}{" "}
                  {
                    trackDetails?.data?.results?.counts
                      ?.community_candidates_count
                  }
                </Typography>
              </Box>
            </Grid>
            {/* <Grid item xs={12} sm={12} md={7} lg={7} sx={{ padding: '10px 10px 10px 0' }}>
                                <TextField
                                    label="Required Skills"
                                    multiline
                                    rows={7}
                                    sx={{ width: "100%", marginBottom: '20px' }}
                                />

                                <TextField
                                    label="Nice to Have Skills"
                                    multiline
                                    rows={5}
                                    sx={{ width: "100%" }}
                                />
                            </Grid> */}
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              sx={{ padding: "15px 14px 0 0" }}
            >
              {trackerLoading === "loading" ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: 230,
                  }}
                >
                  <CircularProgress size={30} color="info" />
                </Box>
              ) : typeResult === "public" ? (
                <>
                  {privateMatching?.length > 0 ? (
                    privateMatching?.map((res, index) => {
                      return (
                        <MoreFilterPublicResume
                          key={index}
                          name={res?.full_name}
                          job={res?.current_job_title}
                          location={getLocationById(res?.current_location)}
                          work={getWorkAuthorization(res?.work_authorization)}
                          skills={matchingSkills(res?.skills)}
                          skills2={matchingSkills2nd(res?.skills)}
                          btn1="View Profile"
                          //   btn2="Send E-Mail"
                          matches=""
                          res={res}
                          toggleSelect={toggleSelect}
                          setSubmisionRow={setSubmisionRow}
                          handleViewShow={handleViewShow}
                          type="private"
                          setType={setType}
                          getPreferLocationNames={getPreferLocationNames}
                        />
                      );
                    })
                  ) : (
                    <div style={{ textAlign: "center", marginTop: "50px" }}>
                      No Candidate Found
                    </div>
                  )}
                </>
              ) : typeResult === "internal" ? (
                <>
                  {publicMatching?.length > 0 ? (
                    publicMatching?.map((res, index) => {
                      return (
                        <MoreFilterPublicResume
                          key={index}
                          name={res?.full_name}
                          job={res?.current_job_title}
                          location={getLocationById(res?.current_location)}
                          work={getWorkAuthorization(res?.work_authorization)}
                          skills={matchingSkills(res?.skills)}
                          skills2={matchingSkills2nd(res?.skills)}
                          btn1="View Profile"
                          //   btn2="Send E-Mail"
                          matches=""
                          res={res}
                          toggleSelect={toggleSelect}
                          setSubmisionRow={setSubmisionRow}
                          handleViewShow={handleViewShow}
                          type="public"
                          setType={setType}
                          getPreferLocationNames={getPreferLocationNames}
                        />
                      );
                    })
                  ) : (
                    <div style={{ textAlign: "center", marginTop: "50px" }}>
                      No Candidate Found
                    </div>
                  )}
                </>
              ) : (
                <>
                  {communitMatching?.length > 0 ? (
                    communitMatching?.map((res, index) => {
                      return (
                        <MoreFilterPublicResume
                          key={index}
                          name={res?.full_name}
                          job={res?.current_job_title}
                          location={getLocationById(res?.current_location)}
                          work={getWorkAuthorization(res?.work_authorization)}
                          skills={matchingSkills(res?.skills)}
                          skills2={matchingSkills2nd(res?.skills)}
                          btn1="View Profile"
                          //   btn2="Send E-Mail"
                          matches=""
                          res={res}
                          toggleSelect={toggleSelect}
                          setSubmisionRow={setSubmisionRow}
                          handleViewShow={handleViewShow}
                          type="community"
                          setType={setType}
                          getPreferLocationNames={getPreferLocationNames}
                        />
                      );
                    })
                  ) : (
                    <div style={{ textAlign: "center", marginTop: "50px" }}>
                      No Candidate Found
                    </div>
                  )}
                </>
              )}
            </Grid>
          </Grid>
          {trackerLoading !== "loading" && (
            <Box
              className={styles.job_search_result_btns}
              sx={{ marginBottom: "20px", padding: "10px 15px" }}
            >
              <button
                style={
                  IsDisablePrevious()
                    ? {
                        backgroundColor: "#3856a6",
                        marginRight: "10px",
                        cursor: "not-allowed",
                      }
                    : { backgroundColor: "#3856a6", marginRight: "10px" }
                }
                onClick={() => handleOnClickNextPrevious("previous")}
                disabled={IsDisablePrevious()}
              >
                {trackerLoading === "loading" ? "Loading" : "Prevoius"}
              </button>
              <button
                style={
                  IsDisableNext()
                    ? {
                        backgroundColor: "#3856a6",
                        marginRight: "10px",
                        cursor: "not-allowed",
                      }
                    : { backgroundColor: "#3856a6", marginRight: "0" }
                }
                onClick={() => handleOnClickNextPrevious("next")}
                disabled={IsDisableNext()}
              >
                {trackerLoading === "loading" ? "Loading" : "Next"}
              </button>
            </Box>
          )}
          {/* <Box className={styles.job_search_result_btns}>
            <button style={{ alignSelf: "flex-end" }}>Select All</button>
          </Box> */}
        </Grid>
      </Grid>

      {/* <Box
        className={styles.internal_update_btns}
        sx={{ padding: "20px !important" }}
      >
        <Box sx={{ position: "relative", left: "250px" }}>
          <span>
            <Typography>
              You have selected {selectedCandidate?.length} candidates from the
              filter
            </Typography>
            <Typography>
              <b> Note: Max 50 send limit in one short.</b>
            </Typography>
          </span>
        </Box>
        <Box>
          <button
            style={
              selectedCandidate?.length === 0
                ? {
                    backgroundColor: "#3856a6",
                    padding: "7.5px 15px",
                    cursor: "not-allowed",
                  }
                : { backgroundColor: "#3856a6", padding: "7.5px 15px" }
            }
            onClick={() => {
              handleShow();
              setHotListRow(selectedCandidate);
            }}
            disabled={selectedCandidate?.length === 0}
          >
            Send Requirement
          </button>
        </Box>
      </Box> */}

      <SearchSelectJobDrawer
        handleShow={handleShow}
        handleClose={handleCloseShow}
        show={show}
        row={hotListRow}
        type="internalTracker"
        handleCloseShowSelected={handleCloseShowSelected}
      />

      <SendRequirementDrawer
        handleShow={handleShowSelected}
        handleClose={handleCloseShowSelected}
        show={showSelected}
        selectedCandidate={selectedCandidate}
        handleShowDwaer={handleShow}
        setHotListRow={setHotListRow}
      />

      <CandidateViewDrawer
        handleShow={handleShowCandidate}
        handleClose={handleCloseShowCandidate}
        show={showCandidate}
        row={submisionRow}
      />
      <InternalCandidateViewdrawer
        handleShow={handleViewShow}
        handleClose={handleCloseView}
        show={showView}
        row={submisionRow}
        type={type}
      />
    </Box>
    // </RootComponents>
  );
};

export default JobSearchResult;
